/**
 * Vite shim for next/navigation — used by @xinosolutions/xs-auth-react
 * (useLogout, DashboardAuthGuard). Maps to react-router-dom.
 */
import {
  useNavigate,
  useLocation,
  useSearchParams as useRRSearchParams,
} from "react-router-dom";

export function useRouter() {
  const navigate = useNavigate();
  const location = useLocation();
  return {
    push: (url) => navigate(url),
    replace: (url) => navigate(url, { replace: true }),
    back: () => navigate(-1),
    forward: () => navigate(1),
    prefetch: async () => {},
    pathname: location.pathname,
    query: Object.fromEntries(new URLSearchParams(location.search)),
    asPath: `${location.pathname}${location.search}${location.hash}`,
  };
}

export function usePathname() {
  return useLocation().pathname;
}

export function useSearchParams() {
  const [params] = useRRSearchParams();
  return params;
}

export function redirect(url) {
  if (typeof window !== "undefined") {
    window.location.href = url;
  }
}

export function notFound() {
  throw new Error("notFound() is not supported in this Vite app");
}
